module.exports = __webpack_public_path__ + "img/head.e8fb0087.png";